import { defineTemplate } from '../../../utils';

export const laTribuClipping = defineTemplate({
  mode: 'legacy',
  id: 'la-tribu',
  clientId: 'GVAZ',
  handlerKey: 'GVAZ',
  title: 'Clipping',
  hiddenFromUI: true,
  hidePromptTemplate: true,
  thumbnail: { url: '', aspectRatio: 'vertical' },
  formFields: []
});
